export default "__VITE_ASSET__wt4MnPy0__"